var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCactusAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C10.3431 2 9 3.34315 9 5V10H7C6.44772 10 6 9.55228 6 9V7C6 5.89543 5.10457 5 4 5C2.89543 5 2 5.89543 2 7V10C2 12.2091 3.79086 14 6 14H9V21.25H2C1.58579 21.25 1.25 21.5858 1.25 22C1.25 22.4142 1.58579 22.75 2 22.75H22C22.4142 22.75 22.75 22.4142 22.75 22C22.75 21.5858 22.4142 21.25 22 21.25H15V17H18C20.2091 17 22 15.2091 22 13V9C22 7.89543 21.1046 7 20 7H19.8C18.6954 7 17.8 7.89543 17.8 9V11.7143C17.8 12.2666 17.3523 12.7143 16.8 12.7143H15V5C15 3.34315 13.6569 2 12 2ZM12.75 6V10C12.75 10.4142 12.4142 10.75 12 10.75C11.5858 10.75 11.25 10.4142 11.25 10V6C11.25 5.58579 11.5858 5.25 12 5.25C12.4142 5.25 12.75 5.58579 12.75 6ZM12 14.25C12.4142 14.25 12.75 14.5858 12.75 15V17C12.75 17.4142 12.4142 17.75 12 17.75C11.5858 17.75 11.25 17.4142 11.25 17V15C11.25 14.5858 11.5858 14.25 12 14.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCactusAlt);
export default __webpack_public_path__ + "static/media/cactus-alt.f469ca7740ea987458c3104393f941de.svg";
export { ForwardRef as ReactComponent };